'use strict'
module.exports = ({
  CLIENT_ID: '713322577537-fuii363ubj7d9n9u5vhdtmlpnp8ufjhp.apps.googleusercontent.com',
  FACEBOOK_ID: '1916541518553574',
  KEY_GOOGLEMAPS: 'AIzaSyBpKqcIEtHa0FymqMI-BI3lgITP4s6wH1c'
});
